module.exports = __webpack_public_path__ + "static/contentBlockDeault-51bd76b64855935315621df6bc1ab23b.png";